import BookOpenIcon from "@heroicons/react/24/solid/BookOpenIcon";
import AboutDescription from "./AboutDescription";
import { VENUE_TABS } from "@/@core/constants/venue-tabs";
import { useTranslation } from "@/hooks/translationContext";

interface props {
  datas: {
    title: string;
    description: string;
  };
}

export default function About(props: props) {
  const { t } = useTranslation();

  const getTextWithOutSpace = () =>
    t("venue-detail-about-card-title", { title: props.datas.title });

  return (
    <div id={VENUE_TABS.ABOUT} className="border border-gray rounded-[32px] p-4 flex flex-col gap-4 mt-6 lg:max-w-[895px]">
      {props.datas.description
        .replace(" ", "")
        .replace("\n", "")
        .replace("<br>", "").length > 0 && (
          <>
            <div className="flex bg-stone-50 rounded-[16px] py-1.5 px-2 justify-between items-center">
              <div className="flex gap-2">
                <BookOpenIcon className="size-5 text-primary" />
                <h2 className="text-primary font-bold text-sm">
                  {getTextWithOutSpace()}
                </h2>
              </div>
            </div>
          </>
        )}

      <AboutDescription description={props.datas.description} />
    </div>
  );
}
